<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-avatar
          :size="size || '120px'"
          color="grey lighten-1"
          v-ripple
          style="overflow: visible"
          @click.stop="pickFile"
      >
        <v-img
            v-if="imageUrl"
            :src="imageUrl"
            alt="Avatar"
        />
        <v-icon v-if="!imageUrl" large color="white">fa-image</v-icon>
        <input
            type="file"
            style="display: none"
            ref="file"
            accept="image/*"
            @change="onFilePicked"
        >
        <v-btn
            absolute
            small
            rounded
            depressed
            bottom
            dark
            @click.stop="pickFile"
            color="primary-grey darken-3"
            class="pl-3 pr-3"
        >{{imgLabel || 'Seleccionar imagen'}}</v-btn>

      </v-avatar>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <v-sheet height="20" color="transparent">
        <small class="accent--text" v-if="maxSizeExceeded">Tamaño excedido (max. {{maxSize}}mb.)</small>
      </v-sheet>
    </v-flex>
  </v-layout>

</template>

<script>
    export default {
        props: ['default', 'size', 'imgLabel', 'maxSize'],
        data(){
            return{
                imageName: '',
                imageUrl: this.default || null,
                imageFile: ''
            }
        },
        mounted() {
          const vm = this
          if (vm.default) {
            vm.imageUrl = vm.default
          }
        },
        methods:{
            pickFile() {
                this.$refs.file.click()
            },
            onFilePicked(e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.imageName = files[0].name
                    if(this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0]
                        this.$emit('change', files[0])
                    })

                    return
                }

                this.imageName = ''
                this.imageFile = ''
                this.imageUrl = ''

            }
        },
      computed:{
          valid(){
            const vm = this
            if(vm.maxSizeExceeded) return false
            return true
          },
          maxSizeExceeded(){
            const vm = this
            return vm.maxSize && vm.fileSize > Number(vm.maxSize)
          },
          fileSize(){
            const vm = this
            return vm.imageFile && (vm.imageFile.size / 1024 / 1024).toFixed(2) || 0
          }
      },
      watch:{
          valid(val){
            this.$emit('change:validation', val)
          },
        default(val){
          const vm = this
          if (val) {
            vm.imageUrl = val
          }
        }
      }
    }
</script>

<style scoped>
    .v-avatar img{
        object-fit: cover;
    }
</style>
